import React from "react";
import Button from "../button/Button";
import "./modal.css"

const Modal = (
    {
        title = "",
        onReturnToSignup,
        onReturn,
        children
    }
) => {

    return (
        <div className="modal-outer">
            <div className="modal-inner">
                <div className="modal-box">
                    <div className="modal-header">
                        <h2 style={{fontSize:"30px", color:"red"}}>{title}</h2>
                    </div>
                    {children}
                    <div className="modal-actions">
                        <Button
                            type="primary"
                            onClick={() => onReturn()}
                            style={{ marginRight: "10px" }}
                            text="Return to previous page"
                        />

                        <Button
                            type="primary"
                            onClick={() => onReturnToSignup()}

                            text="Sign up"
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Modal;